var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sentinel",staticClass:"isLoading-container"},[(_vm.loading)?_c('div',{staticClass:"listLoading",attrs:{"role":"status","aria-live":"polite"}},[_vm._v(_vm._s(_vm.$t('common.listLoading')))]):_vm._e(),(_vm.finished)?_c('div',{staticClass:"listNoMore"},[_vm._v(_vm._s(_vm.$t('common.listNoMore')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }